import { Component, OnInit } from '@angular/core';

@Component({
    // tslint:disable-next-line
    selector: 'tr[euiTableExpandableRow]',
    templateUrl: './eui-table-expandable-row.component.html',
    host: {
        'class': 'eui-table-expandable-row',
    },
})

export class EuiTableExpandableRowComponent implements OnInit {

    constructor() {}

    ngOnInit() {}

}
